import React from "react";
import Reembolso from "./components/Reembolso";
import { ReembolsoExpressProvider } from "./context/reembolsoExpress.context";

const ReembolsoExpress = () => {
  return (
      <ReembolsoExpressProvider>
        <Reembolso />
      </ReembolsoExpressProvider>
  );
};

export default ReembolsoExpress;
